import React, { memo, useMemo } from 'react';

import { useStyles } from './limra-icon.style';
import { useLimraIcon } from './limra-icon.hook';

type ComponentProps = {
  value: string;
};

export const LimraIconComponent: React.FC<ComponentProps> = memo((props: ComponentProps) => {
  const { classes } = useStyles();
  const styles = useMemo(() => classes, [classes]);

  const { total, score } = useLimraIcon({ value: props.value });

  if (props.value === null || props.value === undefined) {
    return null;
  }

  return (
    <span className={styles.wrap}>
      {Array.from({ length: total }, (_, i) => (
        <span key={i} className={`${styles.icon} ${i < score ? styles.active : styles.inactive}`}>
          +
        </span>
      ))}
    </span>
  );
});

/**
 * Function wrapper for backward compatibility.
 * Used in table column render: `render: (row) => LimraIcon(row.field)`
 */
export const LimraIcon = (value: any) => {
  return <LimraIconComponent value={value} />;
};
